import React, { useEffect, useRef } from "react";

import { mountStaticHeaderPackage } from "@lib/staticHeaderPackage";

const Logger = require("shared/services/Logger");

type Props = {
  isLoaded: boolean;
  nonce?: string;
  onLoadChange: (isLoaded: boolean) => void;
  url: string;
};

function StaticHeader({ isLoaded, nonce, onLoadChange, url }: Props) {
  const hostRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const host = hostRef.current;
    const controller = new AbortController();
    let active = true;
    let cleanup = () => {};

    onLoadChange(false);

    if (host) {
      mountStaticHeaderPackage({
        host,
        nonce,
        signal: controller.signal,
        url,
      })
        .then((dispose) => {
          if (!active) {
            dispose();
            return;
          }

          cleanup = dispose;
          onLoadChange(true);
        })
        .catch((error) => {
          if (controller.signal.aborted) {
            return;
          }

          Logger.warn(
            `Static header package could not be loaded: ${
              error instanceof Error ? error.message : String(error)
            }`
          );
          onLoadChange(false);
        });
    }

    return () => {
      active = false;
      controller.abort();
      cleanup();
      onLoadChange(false);
    };
  }, [nonce, onLoadChange, url]);

  return <div data-test-id="static-header" hidden={!isLoaded} ref={hostRef} />;
}

export default StaticHeader;
